
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class TVideo extends Base {
  videoElement: HTMLVideoElement | null = null;

  errorTimeout = -1;

  mounted() {
    if (this.$refs.video)
      this.videoElement = this.$refs.video as HTMLVideoElement;
  }

  get src() {
    return this.config.videoSrc?.toString() || this.config.src?.toString();
  }

  get loop() {
    return this.config.loop === true;
  }

  ended() {
    this.emitDone();
  }

  error() {
    clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => {
      if (this.videoElement) {
        this.videoElement.load();
        this.videoElement.currentTime = 0;
        this.videoElement.play();
      }
    }, 3000);
  }
}
